import styled from "styled-components";
import { Page } from "../styles";
import { Descent } from "./figures";
import CollabChain from "./CollabChain";

const Bio = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
   const Field = styled(Descent)`
  && { margin: 24px 0 36px; }
`;

const ext = { target: "_blank", rel: "noopener noreferrer" };

const lecun = {
  people: ["Jarett Dewbury", "Hossein Mobahi", "Yi Ma", "Yann LeCun"],
  papers: [
    { title: "Sharpness-Aware Minimization (SAM) Improves Classification Accuracy of Bacterial Raman Spectral Data Enabling Portable Diagnostics", url: "https://arxiv.org/pdf/2609.19453" },
    { title: "Segmentation of Natural Images by Texture and Boundary Compression", url: "https://arxiv.org/pdf/1006.3679" },
    { title: "Eyes Wide Shut? Exploring the Visual Shortcomings of Multimodal LLMs", url: "https://arxiv.org/pdf/2401.06209" },
  ],
};

export default function HomePage() {
  return (
    <Page>
      <Bio>
        <p>
          I'm a machine learning engineer at{" "}
          <a href="https://www.altislabs.com/" {...ext}>Altis Labs</a>. I'm also a research scientist at{" "}
          <a href="https://www.mit.edu/" {...ext}>MIT</a> working with{" "}
          <a href="https://meche.mit.edu/people/faculty/lozat@mit.edu" {...ext}>Loza Tadesse</a>.
          I study how the constraints of real-world data can become useful priors for learning.
          I am interested in data-efficient and robust machine learning for settings where labels
          are scarce, measurements are noisy, and resources are limited, with a focus on healthcare.
        </p>
        <p>
          Before MIT I studied biomedical engineering at the University of Waterloo, where I co-founded{" "}
          <a href="https://watai.ca/" {...ext}>WAT.ai</a>. I've also spent time at{" "}
          <a href="https://hms.harvard.edu/" {...ext}>Harvard Medical School</a> and{" "}
          <a href="https://www.massgeneral.org/" {...ext}>Mass General</a>. My work has been supported by{" "}
          <a href="https://www.mercatus.org/emergent-ventures" {...ext}>Emergent Ventures</a> and the{" "}
          <a href="https://uwaterloo.ca/engineering/pearl-sullivan-emerging-global-leaders-award" {...ext}>
            Pearl Sullivan Emerging Global Leaders Award
          </a>.
        </p>
      </Bio>

      <Field />

      <Bio>
        <p>
          I spent most of my life before university playing junior{" "}
          <a href="https://www.eliteprospects.com/player/582668/jarrett-dewbury" {...ext}>hockey</a>.
          Since then, my <CollabChain label="LeCun" number={3} chain={lecun} /> number has dropped to at most three.
        </p>
        <p>
          Feel free to reach out by{" "}
          <a href="mailto:jarett.dewbury@gmail.com">email</a>, or find me on{" "}
          <a href="https://twitter.com/JarettDewbury" {...ext}>X</a>,{" "}
          <a href="https://github.com/Jdewbury" {...ext}>GitHub</a>,{" "}
          <a href="https://www.linkedin.com/in/jarett-dewbury/" {...ext}>LinkedIn</a>, and{" "}
          <a href="https://scholar.google.com/citations?user=coiG25kAAAAJ&hl=en" {...ext}>Scholar</a>.
        </p>
      </Bio>
    </Page>
  );
}